import { CreateActivityLogComponent } from './components/new-activitylog.component';
import { ActivityLogListResolver } from './services/activitylog.services.resolver';
import { ActivityLogServices } from './services/activitylog.services';
import { ActivityLogListComponent } from './components/activitylog-list.component';
import { ActivityLogComponent } from './activitylog.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSharedModule } from './../shared/appShared.module';
import { RouterModule } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { SharedModule } from 'primeng/api';
import { DatePickerModule } from 'primeng/datepicker';
import { EditorModule } from 'primeng/editor';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MenuModule } from 'primeng/menu';
import { DialogModule } from 'primeng/dialog';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';

@NgModule({ declarations: [
        ActivityLogComponent,
        ActivityLogListComponent,
        CreateActivityLogComponent
    ],
    exports: [
        ActivityLogComponent,
        ActivityLogListComponent,
        CreateActivityLogComponent
    ],
    bootstrap: [],
    imports: [
        BrowserModule,
        TableModule,
        SharedModule,
        FormsModule,
        DatePickerModule,
        EditorModule,
        ContextMenuModule,
        MenuModule,
        DialogModule,
        ReactiveFormsModule,
        SelectModule,
        TextareaModule,
        InputTextModule,
        TranslatePipe, TranslateDirective,
        AppSharedModule,
        RouterModule,
        ButtonModule,
        CheckboxModule
    ],
    providers: [ActivityLogServices, ActivityLogListResolver, provideHttpClient(withInterceptorsFromDi())]
})
export class ActivityLogModule {}
